import React, { useState } from 'react';
import { ClickAwayListener, Grid } from '@mui/material';
import { useTypedSelector } from 'hooks/use-typed-selector';
import showBuildInfo from './build_info/show_build_info';
import SendSMSInput from './send_sms_message/send_sms_message_builder';
import CreatePatient from './create_patient/create_patient';
import getFlags from './feature_flags/show_feature_flags';

const itemcss = {
  'padding': '6px 8px 6px 10px',
  '&:hover': { backgroundColor: '#1e90ff', color: 'white', borderRadius: '6px' },
};

const itemcss_disabled = { padding: '6px 8px 6px 10px', color: 'grey' };

const menuStyle = {
  position: 'absolute',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 2px rgba(0, 0, 0, 0.08)',
  background: 'rgb(247, 247, 247)',
  borderRadius: '8px',
  width: '200px',
  padding: '6px 6px',
  fontSize: '13px',
  fontFamily: 'system-ui',
  color: '#1f1f1f',
  textAlign: 'left',
  lineHeight: 1.4,
  border: '0.25px solid grey',
};

const ToolsMenu = props => {
  const { setShowMenu, position } = props;
  const menuStyleWithPosition = { ...menuStyle, top: position.y, left: position.x };
  const isLocal = window.location.hostname === 'local.trellisrx.com';
  const isProduction = window.location.hostname === 'arbor.trellisrx.com';
  const [itemToDisplay, setItemToDisplay] = useState('root_menu');
  const mobile_phone_number_configured = useTypedSelector(state => {
    const enabled_phone_entry = state.patient.filteredPhones?.find(
      item => item.sms === 'Opt in' && item.use === 'Mobile',
    );
    return !!enabled_phone_entry;
  });
  if (itemToDisplay === 'root_menu') {
    return (
      <ClickAwayListener onClickAway={() => setShowMenu(null)}>
        <div className="contextmenu" style={menuStyleWithPosition}>
          <Grid
            sx={isLocal ? itemcss_disabled : itemcss}
            onClick={
              isLocal
                ? () => {}
                : () => {
                    setShowMenu(null);
                    showBuildInfo();
                  }
            }
          >
            Show Build Information
          </Grid>
          <Grid
            sx={itemcss}
            onClick={() => {
              setShowMenu(null);
              getFlags();
            }}
          >
            Show Feature Flags
          </Grid>
          {!isProduction ? (
            <Grid sx={itemcss_disabled} onClick={() => setItemToDisplay('create_patient')}>
              Create Patient
            </Grid>
          ) : null}
          {!isProduction && mobile_phone_number_configured ? (
            <Grid sx={itemcss} onClick={() => setItemToDisplay('sms_form')}>
              Send SMS from Patient
            </Grid>
          ) : null}
        </div>
      </ClickAwayListener>
    );
  }
  if (itemToDisplay === 'sms_form') {
    return <SendSMSInput close={() => setShowMenu(null)} />;
  }
  if (itemToDisplay === 'create_patient') {
    return <CreatePatient close={() => setShowMenu(null)} />;
  }
};

export default ToolsMenu;
